<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="24"
   height="24"
   viewBox="0 0 24 24"
   fill="none"
   stroke="currentColor"
   stroke-width="2"
   stroke-linecap="round"
   stroke-linejoin="round"
   class="feather feather-settings"
   version="1.1"
   id="svg1"
   sodipodi:docname="cog.svg"
   inkscape:version="1.3.2 (091e20ef0f, 2023-11-25, custom)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs1" />
  <sodipodi:namedview
     id="namedview1"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="30.708333"
     inkscape:cx="12.016282"
     inkscape:cy="12.895522"
     inkscape:window-width="1916"
     inkscape:window-height="1036"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="0"
     inkscape:current-layer="svg1"
     showguides="true" />
  <circle
     cx="12"
     cy="12"
     id="circle1"
     r="2.7"
     style="stroke-width:1.8" />
  <path
     d="m 18.66,14.7 a 1.485,1.485 0 0 0 0.297,1.638 l 0.054,0.054 a 1.8,1.8 0 0 1 0,2.547 1.8,1.8 0 0 1 -2.547,0 L 16.41,18.885 a 1.485,1.485 0 0 0 -1.638,-0.297 1.485,1.485 0 0 0 -0.9,1.359 V 20.1 a 1.8,1.8 0 0 1 -1.8,1.8 1.8,1.8 0 0 1 -1.8,-1.8 V 20.019 A 1.485,1.485 0 0 0 9.3,18.66 1.485,1.485 0 0 0 7.662,18.957 l -0.054,0.054 a 1.8,1.8 0 0 1 -2.547,0 1.8,1.8 0 0 1 0,-2.547 L 5.115,16.41 a 1.485,1.485 0 0 0 0.297,-1.638 1.485,1.485 0 0 0 -1.359,-0.9 H 3.9 a 1.8,1.8 0 0 1 -1.8,-1.8 1.8,1.8 0 0 1 1.8,-1.8 H 3.981 A 1.485,1.485 0 0 0 5.34,9.3 1.485,1.485 0 0 0 5.043,7.662 L 4.989,7.608 a 1.8,1.8 0 0 1 0,-2.547 1.8,1.8 0 0 1 2.547,0 L 7.59,5.115 A 1.485,1.485 0 0 0 9.228,5.412 H 9.3 A 1.485,1.485 0 0 0 10.2,4.053 V 3.9 A 1.8,1.8 0 0 1 12,2.1 1.8,1.8 0 0 1 13.8,3.9 v 0.081 a 1.485,1.485 0 0 0 0.9,1.359 1.485,1.485 0 0 0 1.638,-0.297 l 0.054,-0.054 a 1.8,1.8 0 0 1 2.547,0 1.8,1.8 0 0 1 0,2.547 L 18.885,7.59 A 1.485,1.485 0 0 0 18.588,9.228 V 9.3 a 1.485,1.485 0 0 0 1.359,0.9 H 20.1 a 1.8,1.8 0 0 1 1.8,1.8 1.8,1.8 0 0 1 -1.8,1.8 h -0.081 a 1.485,1.485 0 0 0 -1.359,0.9 z"
     id="path1"
     style="stroke-width:1.8" />
</svg>
